import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import { Button } from 'reactstrap';
import swal from 'sweetalert';

import background from '../../images/background.svg';
import logo from '../../images/logo.svg';
import authStore from '../../../stores/auth-store';

class ForgotPassword extends Component{
    constructor(props) {
        super(props);
        this.state = {
            email:'',                                                                               
            Invalid: false,
            isVarified:false,
        };
    }
   

    handleSubmit = (e) => {
        e.preventDefault();
        
        if(this.state.email){
            authStore.forgotPassword({ email: this.state.email })
            .then(({data}) => {
                if (data.success) {
                    swal({
                        title: "Success",
                        text: data.status,
                        icon: "success",
                        dangerMode: false,
                    })
                    localStorage.setItem("forgot-email",this.state.email);
                     this.props.history.push({pathname: '/reset'})
                }
                else{
                    throw new Error(data.err);
                }
            }).catch(err => {
                swal({
                    title: "Error",
                    text: err.message,
                    dangerMode: true,
                })
                this.setState({ Invalid: err.message });
                setTimeout(() => {
                    this.setState({ Invalid: false });
                }, 4000); 
            })
        }
        else {
            this.setState({ Invalid: 'Please fill email properly' });
            setTimeout(() => {
                this.setState({ Invalid: false });
            }, 4000); 
        }
    }
    handleEmailChange = (e) => {
        this.setState({
            email: e.target.value
        })
    }
    render(){
        let {Invalid} =this.state;
        return(
            <div className="row"
                style={{ backgroundImage: `url(${background})`, minHeight: '100vh', backgroundSize: 'cover', width: '100%', margin: '0px', overflow: 'hidden' }}>
            <div className="col-md-12">
                <div className="Login">
                    <form onSubmit={this.handleSubmit}>
                        <img src={logo} alt="logo" />
                        {
                            Invalid ?
                                <label style={{ color: 'red', marginBottom: '12px' }}>{Invalid}</label>
                                : ''
                        }
                        <div className="input-container">
                                <i className="fa fa-envelope icon"></i>
                                <input className="input-field" type="email" placeholder="Enter Email"
                                    id="email"
                                    value={this.state.email}
                                    onChange={this.handleEmailChange}
                                    type="email"
                                />
                        </div>

                        <Button
                            block
                            bsSize="large"
                            type="submit"
                            className="lightBlueButton btn btn-lg btn-default btn-block"
                        >
                            Forgot password
                        </Button>
                        <div onClick={() =>  this.props.history.push('/login')} className="textRightLink">
                            Back
                        </div>
                    </form>
                </div>
            </div>
        </div>
        )
    }
}

export default withRouter(ForgotPassword);